export default "__VITE_ASSET__$V2avmvE__"